import './steelehillresorts1/style';
import FormStructure from './steelehillresorts1/form_structure';

export default FormStructure;